/**
 * CP-252: which sailing Detail opens on when the URL has no ?sail_date.
 *
 * Since CP-112 every row is one sailing, and its own departure_date is the
 * sail whose fare the scraper still refreshes. available_sail_dates can also
 * list sibling dates left in PriceHistory by the old collapsed rows; those
 * are frozen ("Price not current"), so the soonest of them must not win over
 * the row's own date. The soonest upcoming entry is only a fallback for a
 * row whose own date is missing or already departed.
 *
 * isUpcoming(value) and sailDay(value) are the Detail page helpers (UTC
 * today inclusive, YYYY-MM-DD), passed in so this stays a pure function.
 */
export function pickDefaultSailDate(info, isUpcoming, sailDay) {
  const own = info && info.departure_date;
  if (own && isUpcoming(own)) return own;
  const dates = (info && info.available_sail_dates) || [];
  return dates
    .filter((d) => isUpcoming(d))
    .sort((a, b) => sailDay(a).localeCompare(sailDay(b)))[0];
}
